import { metrics } from '@atlassian/browser-metrics';

export const boardsDirectoryPageLoad = metrics.pageLoad({
	key: 'boards-directory',
	ssr: {
		doneAsFmp: true,
	},
});
